<div class="tw-py-[0.3125rem]">
  @if (!isLoadingRules()) {
    @if (flightBookingRules()) {
      <ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="{
          roundTrip: false,
          details: flightBookingRules(),
        }"
      ></ng-container>
    }

    @if (roundTripFlightBookingRules()) {
      <ng-container
        [ngTemplateOutlet]="content"
        [ngTemplateOutletContext]="{
          roundTrip: true,
          details: roundTripFlightBookingRules(),
        }"
      ></ng-container>
    }
  } @else {
    <ng-container
      [ngTemplateOutlet]="loading"
      [ngTemplateOutletContext]="{ roundTrip: false }"
    ></ng-container>
    @if (selectFlightState.roundTrip()) {
      <ng-container
        [ngTemplateOutlet]="loading"
        [ngTemplateOutletContext]="{ roundTrip: true }"
      ></ng-container>
    }
  }
</div>

<ng-template #content let-roundTrip="roundTrip" let-details="details">
  <div>
    <span
      class="tw-my-2.5 tw-inline-block tw-text-[0.9375rem] tw-text-[#ea6153]"
    >
      {{ roundTrip === false ? "1. Chiều đi:" : "2. Chiều về" }}
    </span>
    @for (item of details; track $index) {
      <div class="tw-mb-2.5 tw-overflow-x-auto">
        <table class="tw-w-full tw-text-sm">
          <thead class="tw-bg-[#ea6153] tw-text-primary-content">
            <tr class="tw-border tw-border-[#ea6153]">
              <th class="tw-w-[30%] tw-border-r tw-border-current tw-p-1">
                Hạng ghế:
              </th>
              <th class="tw-border-r tw-p-1">
                {{ item.segment.fareClass }}
                @if (
                  item.segment.airline === "9G" || item.segment.airline === "QH"
                ) {
                  ({{ item.segment.groupClass }})
                }
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="tw-border-b tw-border-[#ea6153] hover:tw-bg-base-100">
              <td
                colspan="100%"
                class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r"
              >
                <span class="tw-font-bold tw-text-base-900">1. Hành lý:</span>
              </td>
            </tr>
            @for (rule of item.bookingRules; track $index) {
              @if (rule.isActive && rule.rule === BookingRuleEnum.Luggage) {
                <tr
                  class="tw-border-b tw-border-[#ea6153] hover:tw-bg-base-100"
                >
                  <td
                    class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r"
                  >
                    {{ rule.title }}
                  </td>
                  <td
                    class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r"
                  >
                    {{ rule.content }}
                  </td>
                </tr>
              }
            }

            <tr class="tw-border-b tw-border-[#ea6153] hover:tw-bg-base-100">
              <td
                colspan="100%"
                class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r"
              >
                <span class="tw-font-bold tw-text-base-900">2. Điều kiện:</span>
              </td>
            </tr>
            @for (rule of item.bookingRules; track $index) {
              @if (rule.isActive && rule.rule === BookingRuleEnum.Ticket) {
                <tr
                  class="tw-border-b tw-border-[#ea6153] hover:tw-bg-base-100"
                >
                  <td
                    class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r"
                  >
                    {{ rule.title }}
                  </td>
                  <td
                    class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r"
                  >
                    {{ rule.content }}
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</ng-template>

<ng-template #loading let-roundTrip="roundTrip">
  <span class="tw-my-2.5 tw-inline-block tw-text-[0.9375rem] tw-text-[#ea6153]">
    {{ roundTrip === false ? "1. Chiều đi:" : "2. Chiều về" }}
  </span>
  <div class="tw-mb-2.5 tw-w-full tw-overflow-auto">
    <table class="tw-w-full tw-text-sm">
      <thead class="tw-bg-[#ea6153] tw-text-primary-content">
        <tr class="tw-border tw-border-[#ea6153]">
          <th class="tw-w-[30%] tw-border-r tw-border-current tw-p-1">
            Hạng ghế:
          </th>
          <th class="tw-border-r tw-p-1"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="tw-border-b tw-border-[#ea6153] hover:tw-bg-base-100">
          <td
            colspan="100%"
            class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r"
          >
            <span class="tw-font-bold tw-text-base-900">1. Hành lý:</span>
          </td>
        </tr>
        @for (item of [1, 2]; track $index) {
          <tr class="tw-border-b tw-border-[#ea6153] hover:tw-bg-base-100">
            <td class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r">
              <p
                class="tw-h-3 tw-animate-pulse tw-rounded-full tw-bg-gray-200"
              ></p>
            </td>
            <td class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r">
              <p
                class="tw-h-3 tw-animate-pulse tw-rounded-full tw-bg-gray-200"
              ></p>
            </td>
          </tr>
        }
        <tr class="tw-border-b tw-border-[#ea6153] hover:tw-bg-base-100">
          <td
            colspan="100%"
            class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r"
          >
            <span class="tw-font-bold tw-text-base-900"> 2. Điều kiện: </span>
          </td>
        </tr>
        @for (item of [1, 2, 3]; track $index) {
          <tr class="tw-border-b tw-border-[#ea6153] hover:tw-bg-base-100">
            <td class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r">
              <p
                class="tw-h-3 tw-animate-pulse tw-rounded-full tw-bg-gray-200"
              ></p>
            </td>
            <td class="tw-border-l tw-border-[#ea6153] tw-p-1 last:tw-border-r">
              <p
                class="tw-h-3 tw-animate-pulse tw-rounded-full tw-bg-gray-200"
              ></p>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</ng-template>
